var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"dynamicClass":'container-fluid'}},[_c('calendar_component',{attrs:{"pageTitle":"Shifts Schedule"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }